export default "__VITE_PUBLIC_ASSET__0d028dd7__"